import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'
import { WholesaleOrderReqType } from '@schemas'

/**
 * 도매 주문 (DISPATCH_PLAN §5). 거래처 본인 경로는 **고객 토큰**을 customHeaders 로 넘겨야 한다 —
 * `Api.connection` 은 localStorage 의 스태프 토큰을 먼저 집는다(customerOrder.saga 와 같은 이유).
 * `/admin/...` 은 백오피스(스태프 토큰).
 */
export const getWholesaleCatalog = async ({ customHeaders = {} } = {}): Promise<
	ResType | undefined
> => {
	try {
		const req = new ApiRequest({
			method: 'get',
			uri: '/wholesale/catalog',
			customHeaders,
		})
		return await Api.connection(req)
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const quoteWholesale = async ({
	body = { items: [] } as {
		items: { productId: string; qty: number }[]
		shippingAmount?: number
		dutyAmount?: number
	},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const req = new ApiRequest({
			method: 'post',
			uri: '/wholesale/quote',
			body,
			customHeaders,
		})
		return await Api.connection(req)
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const createWholesaleOrder = async ({
	body = {} as WholesaleOrderReqType,
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const req = new ApiRequest({
			method: 'post',
			uri: '/wholesale/order',
			body,
			customHeaders,
		})
		return await Api.connection(req)
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const getWholesaleOrders = async ({ customHeaders = {} } = {}): Promise<
	ResType | undefined
> => {
	try {
		const req = new ApiRequest({ method: 'get', uri: '/wholesale/order', customHeaders })
		return await Api.connection(req)
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

// ── 관리자 대리 입력 ─────────────────────────────────────────
export const adminGetWholesaleCatalog = async ({
	params = { customerId: '' },
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const req = new ApiRequest({
			method: 'get',
			uri: `/wholesale/admin/catalog/${params.customerId}`,
			customHeaders,
		})
		return await Api.connection(req)
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const adminQuoteWholesale = async ({
	params = { customerId: '' },
	body = { items: [] } as {
		items: { productId: string; qty: number }[]
		shippingAmount?: number
		dutyAmount?: number
	},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const req = new ApiRequest({
			method: 'post',
			uri: `/wholesale/admin/quote/${params.customerId}`,
			body,
			customHeaders,
		})
		return await Api.connection(req)
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const adminCreateWholesaleOrder = async ({
	params = { customerId: '' },
	body = {} as WholesaleOrderReqType,
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const req = new ApiRequest({
			method: 'post',
			uri: `/wholesale/admin/order/${params.customerId}`,
			body,
			customHeaders,
		})
		return await Api.connection(req)
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

const wholesaleApi = {
	getWholesaleCatalog,
	quoteWholesale,
	createWholesaleOrder,
	getWholesaleOrders,
	adminGetWholesaleCatalog,
	adminQuoteWholesale,
	adminCreateWholesaleOrder,
}

export default wholesaleApi
